/**
 * The content-lint rules in force — `GET /v1/admin/content-lint/rules` — read so an editor can
 * check copy before the round-trip (doc 05-admin/10 §2.1). The server stays the enforcement;
 * this is the same phrase list, shipped as data.
 */
import { useQuery } from '@tanstack/react-query';
import { authedClient } from '../../auth/session';
import { keys } from '../queryClient';
import type { components } from '../../../api/generated/schema';

export type LintRule = components['schemas']['LintRuleRow'];

/** Both scopes that reach a copy editor (superadmin, catalogue_content) may read the rules. */
export function useLintRules() {
  return useQuery({
    queryKey: keys.lintRules(),
    queryFn: () =>
      authedClient.request<components['schemas']['LintRuleListResponse']>(
        '/v1/admin/content-lint/rules',
      ),
    /* The corpus changes by a reviewed migration, not by the minute. */
    staleTime: 60 * 60 * 1000,
  });
}
